import orderOptimizerRoutesUrls from "./order-optimizer-routes-urls";
import OrderOptimizerDetailsRouteParams from "./types/order-optimizer-details-route-params";

const getListingRoute = (): string => {
  return orderOptimizerRoutesUrls.listing;
};

const getListingRouteWithOrderHumanId = (
  orderHumanId: number,
  maximumDelay: number,
): string => {
  return `${orderOptimizerRoutesUrls.listing}?orderHumanId=${orderHumanId}&maximumDelay=${maximumDelay}`;
};

const getDetailsRoute = (params: OrderOptimizerDetailsRouteParams): string => {
  return orderOptimizerRoutesUrls.details
    .replace(":id", params.id)
    .replace(":excludedOrders", params.excludedOrders ?? "all-orders");
};

const orderOptimizerRoutesHelper = {
  getListingRoute,
  getListingRouteWithOrderHumanId,
  getDetailsRoute,
};

export default orderOptimizerRoutesHelper;
